import React from 'react';
import { Link } from 'react-router-dom';
import AboutSection from '../components/about';
import GallerySection from '../components/gallery';
import ContactSection from '../components/contact';

const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900 overflow-hidden">
      {/* Subtle Background Elements */}
      <div className="absolute inset-0 z-[-1] pointer-events-none">
        <div className="w-full h-full bg-[radial-gradient(circle_at_center,#f5e8c7_0%,transparent_70%)] opacity-50 animate-spin-slow" />
        <div className="absolute top-0 left-0 w-64 h-64 bg-yellow-300 rounded-full filter blur-3xl opacity-20 animate-pulse-slow" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-200 rounded-full filter blur-3xl opacity-20 animate-pulse-slow delay-100" />
      </div>

      <main className="flex-grow relative z-10">
        {/* Hero Section */}
        <section className="text-center px-6 py-20 md:py-32 relative">
          <div className="max-w-5xl mx-auto">
            {/* Glitchy Title */}
            <h1 className="text-4xl md:text-7xl font-extrabold mb-6 leading-tight animate-fade-in tracking-tight">
              <span className="text-transparent bg-clip-text bg-black">
             
              National Ethio{' '}

                Cyber Talent
              </span>
              <br className="hidden md:block" />
              <span className="block mt-2 text-5xl md:text-8xl text-gray-800 drop-shadow-lg animate-pulse-slow">
                Summer Camp 2025
              </span>
            </h1>

            {/* Subtitle with Glow */}
            <p className="text-lg md:text-2xl text-gray-700 mb-10 animate-fade-in delay-200 font-light tracking-wide drop-shadow-md">
              <span className="text-yellow-600 animate-glow">🚀 Registration Open!</span> Join Ethiopia's brightest minds for a summer of{' '}
              <span className="underline decoration-wavy decoration-yellow-400">cybersecurity</span>, coding, and creativity.
            </p>

            {/* Button with Hover Effect */}
            <Link
              to="/register"
              className="inline-block bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white text-lg md:text-xl font-semibold px-10 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 animate-fade-in delay-300 border border-yellow-400 hover:border-orange-400 animate-glow-button"
            >
              Register Now
            </Link>
          </div>

          {/* Logo Overlay */}
          <div className="absolute inset-0 z-[-1] flex items-center justify-center">
            <img
              src="./images/logo.png" 
              alt="INSA Logo"
              className="w-1/2 md:w-1/3 opacity-15 animate-float"
            />
          </div>
        </section>

        {/* About Section*/}
         <AboutSection/>


        {/* Gallery Section*/}
         <GallerySection/>


        {/* Contact Section*/}
         <ContactSection/>
      </main>

      {/* Floating Orbs */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute top-10 left-10 w-8 h-8 bg-yellow-300 rounded-full animate-float-slow opacity-40 filter blur-md" />
        <div className="absolute bottom-20 right-20 w-12 h-12 bg-orange-300 rounded-full animate-float-slow delay-100 opacity-40 filter blur-md" />
      </div>
    </div>
  );
};

export default HomePage;